module.exports = __webpack_public_path__ + "img/icon68.42845a33.png";